import { useReducer } from 'react'
// helpers
const initial = {
  open: false,
  page: 1,
  dirtyBit: false,
  searchInput: '',
  filterSelected: null,
  transactionsData: []
}
const reducer = (state, action) => {
  const actions = {
    setPage: page => ({ ...state, page, dirtyBit: true }),
    setSearchInput: searchInput => ({
      ...state,
      searchInput,
      page: 1,
      dirtyBit: true
    }),
    setDirtyBit: dirtyBit => ({ ...state, dirtyBit }),
    setFilterSelected: filterSelected => ({
      ...state,
      filterSelected,
      page: 1
    }),
    setTransactionData: transactionsData => ({
      ...state,
      transactionsData,
      dirtyBit: false
    }),
    setOpen: open => ({ ...state, open })
  }
  return actions[action.type]?.(action.val)
}
const useCreateStore = () => {
  const [states, dispatch] = useReducer(reducer, initial)
  const actions = {
    onOpen: () => dispatch({ type: 'setOpen', val: true }),
    onClose: () => dispatch({ type: 'setOpen', val: false }),
    setPage: val => dispatch({ type: 'setPage', val }),
    setDirtyBit: val => dispatch({ type: 'setDirtyBit', val }),
    setSearchInput: val => dispatch({ type: 'setSearchInput', val }),
    setFilterSelected: val => dispatch({ type: 'setFilterSelected', val }),
    setTransactionData: val => dispatch({ type: 'setTransactionData', val })
  }
  return [states, actions]
}
export default useCreateStore
